import enUs from 'date-fns/locale/en-US';
import * as React from 'react';
import * as ReactDatePickerNS from 'react-datepicker';
import type ReactDatePickerType from 'react-datepicker';

import * as TimeUtils from '@acceligentllc/shared/utils/time';

import { TimeFormat } from '@acceligentllc/shared/enums/timeFormat';

import { RectangleButton } from 'af-components/MultipleOptionsButton/RectangleButton';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const DatePicker = ((ReactDatePickerNS as any).default?.default ?? (ReactDatePickerNS as any).default ?? ReactDatePickerNS) as typeof ReactDatePickerType;

interface OwnProps {
	selected: Date;
	onChange: (selected: Date, startDate: Date, endDate: Date) => void;
}

type Props = OwnProps;

interface State {
	weekDays: Date[];
}

class WeeklyPicker extends React.Component<Props, State> {
	state: State = {
		weekDays: [],
	};

	private _datepicker: Nullable<ReactDatePickerType> = null;

	componentDidMount() {
		const { selected } = this.props;
		this.setWeekDays(selected, false);
	}

	setWeekDays = (value: Date, sendChange: boolean) => {
		const { onChange } = this.props;
		const { weekDays } = this.state;

		if (weekDays.includes(value)) {
			return;
		}

		const momentDate = TimeUtils.parseMoment(value);

		if (!momentDate) {
			throw new Error('Incorrect date provided');
		}

		const startDate = momentDate.clone().startOf('week');
		const endDate = momentDate.clone().endOf('week');
		const newWeekDays: Date[] = [];

		for (let i = 0; i < 7; i++) {
			newWeekDays.push(startDate.clone().add(i, 'days').toDate());
		}

		this.setState(
			() => ({ weekDays: newWeekDays }),
			() => {
				if (sendChange) {
					onChange(value, startDate.toDate(), endDate.toDate());
				}
			}
		);

	};

	onDateChange = (date: Nullable<Date>) => {
		this.setWeekDays(date ?? new Date(), true);
	};

	setDatepickerRef = (datepicker: ReactDatePickerType) => { this._datepicker = datepicker; };

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	focusDatePicker = () => (this._datepicker as any).input.focus();

	render() {
		const { selected } = this.props;
		const { weekDays } = this.state;

		return (
			<div className="table-filter__date week-picker">
				<DatePicker
					className="form-control"
					dateFormat={TimeUtils.datePickerFormat(TimeFormat.DATE_ONLY)}
					disabledKeyboardNavigation
					dropdownMode="select"
					highlightDates={weekDays}
					locale={enUs}
					onChange={this.onDateChange}
					ref={this.setDatepickerRef}
					selected={selected}
					showMonthDropdown={true}
					showYearDropdown={true}
					todayButton="Today"
				/>
				<RectangleButton
					action={this.focusDatePicker}
					isLeftOpen={true}
					isSquare={true}
					label={<span className="icon-calendar" />}
				/>
			</div>
		);
	}
}

export default WeeklyPicker;
